import { HTTP } from './http-common';
export default {
  getEpaycoData(externalId) {
    return HTTP.get('/miQnt/Pay/payment-config/'+ externalId);
  },

  paymentConfirmation(data) {
    return HTTP.post("/qnt/pay/confirmation/")
  }
}